import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MinisterService } from '../../../../services/minister/minister.service';
import { AlertComponent } from '../../../../components/alert/alert.component';
import { MatDialog } from '@angular/material';
import { Minister } from '../../../../models/minister.model';

import { GeneralService } from '../../../../services/general/general.service';


@Component({
  selector: 'app-ver-postulacion',
  templateUrl: './ver-postulacion.component.html',
  styleUrls: ['./ver-postulacion.component.scss']
})
export class VerPostulacionComponent implements OnInit {

  minister: Minister = null;

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private ministerService: MinisterService,
    private generalService: GeneralService,
    private dialog: MatDialog) {

    this.activatedRoute.params.subscribe((parameters) => {
      if (parameters.id) {
        this.ministerService.getMinisterByUserId(parameters.id)
          .subscribe((data: Minister) => {

            // SI EL USUARIO YA MINISTRO, YA NO PUEDE VER LA POSTULACIÓN
            if (data.user.is_academic) {
              this.getOutOfHere("Lo sentimos", "Este usuario ya es ministro");
              return;
            }

            this.minister = data;

            console.log(this.minister);

          }, (error) => {

            this.getOutOfHere("Lo sentimos", "Este usuario no tiene postulación a ministro");
          })
      }
    })
  }

  getOutOfHere(title: string, message: string) {
    this.dialog.open(AlertComponent, {
      width: '35vw',
      disableClose: true,
      data: {
        title: title,
        content: message
      }
    })

    this.router.navigate(['/', 'admin', 'ministers', 'minister-list']);
  }

  ngOnInit() {
  }

  approveRequest() {
    this.ministerService.resolveRequest(this.minister.id, '01', this.minister.level)
      .subscribe((data) => {

        this.getOutOfHere("Felicitaciones", "La solicitud fue aceptada exitósamente")
      }, (error) => {

        this.getOutOfHere("Lo sentimos", "Hubo un error en el servidor")
      })
  }

  rejectRequest() {
    this.ministerService.resolveRequest(this.minister.id, '04', this.minister.level)
      .subscribe((data) => {

        this.getOutOfHere("Solicitud rechazada", "La solicitud fue rechazada exitósamente")
      }, (error) => {

        this.getOutOfHere("Lo sentimos", "Hubo un error en el servidor")
      })
  }


  getConcept(value: string, conceptId: number) {
    let returnValue = '';
    const documentTypes = this.generalService.concepts[conceptId];
    Object.keys(documentTypes).forEach((key) => {
      if (value == documentTypes[key]['value']) {
        returnValue = documentTypes[key]['description']
      }
    });
    return returnValue
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/pages/ministers/ver-postulacion/ver-postulacion.component.ts